// extracted by mini-css-extract-plugin
export default {"body":"gasStationOwnershipRequestModal_body__m2Ypl"};